import { IPublicClientApplication } from "@azure/msal-browser";
import { ExamDetails } from "../models/IExamDetails";
import { BaseService } from "./base.service";

export class ExaminerService extends BaseService {
  constructor(instance: IPublicClientApplication) {
    super(instance);
  }

  public async getExamDetails(meetingId: string): Promise<ExamDetails> {
    // Original
    // var options = this.getHeaderOption("GET");
    // const response = await fetch(
    //   `${this.getEndPoint()}/api/examiner?meetingId=${meetingId}`,
    //   options
    // );

    // New Refetch Token
    const url = `${this.getEndPoint()}/api/examiner?meetingId=${meetingId}`;
    const method = "GET";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      const responseAsJson = await response.json();
      return responseAsJson;
    }
    throw "Invalid examiner response";
  }

  // Purely for testing purposes
  public async pingTest(): Promise<string> {
    // var options = this.getHeaderOption("GET");
    const url = `${this.getEndPoint()}/api/examiner/ping`;
    const method = "GET";

    try {
      const response = await this.getHeaderOptionWithToken(url, method);

      if (response.ok) {
        return response.text();
      } else {
        throw new Error("Error");
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
